"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("@mui/material/styles");
var react_1 = require("react");
var WizardParts_1 = require("../WelcomeFlow/WizardParts");
var CompanyMeta_1 = __importDefault(require("./CompanyMeta"));
var LogoSection_1 = __importDefault(require("./LogoSection"));
var SaaSAuditImg_1 = __importDefault(require("./SaaSAuditImg"));
var TeamsSkeleton_1 = __importDefault(require("./TeamsSkeleton"));
var Wrapper = (0, styles_1.styled)('div')(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            borderRadius: 10,
            maxWidth: 754,
            backgroundColor: theme.palette.common.white
        },
        _b[theme.breakpoints.only('xl')] = {
            padding: theme.spacing(5),
        },
        _b[theme.breakpoints.up('md')] = {
            padding: theme.spacing(3),
        },
        _b);
});
var LivePreview = function () {
    var wizardContext = (0, react_1.useContext)(WizardParts_1.WizardContext);
    return ((0, jsx_runtime_1.jsx)("div", { children: (wizardContext === null || wizardContext === void 0 ? void 0 : wizardContext.currentStep) === 'REQUEST_AUDIT' && 'IS AUDIT STEP'
            ? (0, jsx_runtime_1.jsx)(SaaSAuditImg_1.default, { src: "/SaaSAudits.png", alt: "SaaS Audit feature" })
            : ((0, jsx_runtime_1.jsxs)(Wrapper, { children: [(0, jsx_runtime_1.jsx)(LogoSection_1.default, {}), (0, jsx_runtime_1.jsx)(CompanyMeta_1.default, {}), (0, jsx_runtime_1.jsx)(TeamsSkeleton_1.default, {})] })) }));
};
exports.default = LivePreview;
